/**
 * Notification Component
 */
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React, {Component} from 'react';
import {Badge, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap';
// api
// intl messages
import IntlMessage from 'Util/IntlMessage.tsx';

class Notifications extends Component {
    state = {
        notifications: null,
        newNotifications: [], //['1', '2']
    };

    componentDidMount() {
        this.getNotifications();
    }

    // get notifications
    getNotifications() {
        // api.get('notifications.js')
        //     .then((response) => {
        //         this.setState({notifications: response.data});
        //     })
        //     .catch(error => {
        //         console.log(error);
        //     })
    }

    render() {
        const {notifications, newNotifications} = this.state;
        return (
            <UncontrolledDropdown nav className="list-inline-item notification-dropdown">
                <DropdownToggle nav className="p-0">
                    <Tooltip title="Notifications" placement="bottom">
                        {newNotifications.length ? (
                            <IconButton className="shake" aria-label="bell">
                                <i className="zmdi zmdi-notifications-active"></i>
                                <Badge color="danger" className="badge-xs badge-top-right rct-notify">
                                    {newNotifications.length}
                                </Badge>
                            </IconButton>
                        ) : (
                            <IconButton aria-label="bell">
                                <i className="zmdi zmdi-notifications-active"></i>
                            </IconButton>
                        )}
                    </Tooltip>
                </DropdownToggle>
                <DropdownMenu right>
                    <div className="dropdown-content">
                        <div className="dropdown-top d-flex justify-content-between rounded-top bg-primary">
                            <span className="text-white font-weight-bold">
                                <IntlMessage id="widgets.recentNotifications" />
                            </span>
                            <Badge color="warning">{newNotifications.length} NEW</Badge>
                        </div>
                        <div className="scroller">
                            <ul className="list-unstyled dropdown-list">
                                {notifications &&
                                notifications.map((notification, key) => (
                                    <li key={key}>
                                        <div className="media">
                                            <div className="mr-10">
                                                <img
                                                    src={notification.userAvatar}
                                                    alt="user profile"
                                                    className="media-object rounded-circle"
                                                    width="50"
                                                    height="50"
                                                />
                                            </div>
                                            <div className="media-body pt-5">
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="mb-5 text-primary">{notification.userName}</h5>
                                                    <span className="text-muted fs-12">{notification.date}</span>
                                                </div>
                                                <span className="text-muted fs-12 d-block">{notification.notification}</span>
                                                <Button className="btn-xs mr-10">
                                                    <i className="zmdi zmdi-mail-reply mr-2"></i>
                                                    <IntlMessage id="button.reply" />
                                                </Button>
                                                <Button className="btn-xs">
                                                    <i className="zmdi zmdi-thumb-up mr-2"></i>
                                                    <IntlMessage id="button.like" />
                                                </Button>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="dropdown-foot p-2 bg-white rounded-bottom">
                        <Button variant="contained" color="primary" className="mr-10 btn-xs bg-primary">
                            <IntlMessage id="button.viewAll" />
                        </Button>
                    </div>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }
}

export default Notifications;
